import { Component } from '@angular/core';

@Component({
  selector: 't-app-tile-icon',
  standalone: true,
  imports: [],
  templateUrl: './app-tile-icon.component.html',
  styleUrl: './app-tile-icon.component.css',
})
export class AppTileIconComponent {}
